export default "__VITE_ASSET__x4iKIL13__"